import React from "react";

export default function withLayout<T>(LayoutComponent: React.ComponentType<T>) {
  LayoutComponent.displayName = `withLayout(${LayoutComponent.displayName ||
    LayoutComponent.name ||
    "Component"})`;

  return (props: T) => <LayoutComponent {...props} />;
}
